import { franchiseOnlyGuard } from '@/router/franchiseOnlyGuard'
import FranchiseDay from '@/view/franchise/FranchiseDay.vue'
import FranchiseDayLocation from '@/view/franchise/FranchiseDayLocation.vue'

// One production day across every location, and the same day for one location.
export const franchiseDayRoutes = [
  {
    path: '/dashboard/days/:date/locations/:merchantId/:tab?',
    component: FranchiseDayLocation,
    meta: { title: 'Production day' },
    beforeEnter: franchiseOnlyGuard
  },
  {
    path: '/dashboard/days/:date/:tab?',
    component: FranchiseDay,
    meta: { title: 'Production day' },
    beforeEnter: franchiseOnlyGuard
  }
]
